import React, { useRef, useState, useEffect, useCallback } from 'react';
import SaveFormantsFlow from "components/instruments/SaveFormantsFlow.js";
import PresetsExplorer from "components/installation/PresetsExplorer.js";
import ContextMenu from "components/dropdowns/ContextMenu.js"
import {useContextMenu} from "components/dropdowns/useContextMenu.js"
import MenuItem from "components/dropdowns/MenuItem.js";
import SystemEnvelopeComponent from "components/envelope/SystemEnvelopeComponent.js"
import SingleLFOComponent from "components/lfo/SingleLFOComponent.js"
import MainFMParameters from "components/instruments/MainFMParameters.js";
import FormantEffect from './fm/FormantEffect.js';
import {connect} from 'react-redux';
import OperatorsMixer from './fm/OperatorsMixer.js';
import FilterSection from './FilterSection.js';
import FMParameter from './FMParameter.js';
import OscInfo from './OscInfo.js';
import OscillatorsContinuedComponent from './OscillatorsContinuedComponent.js';
import RackComponent from "components/effects/rack/RackComponent.js";
import Colors from 'components/Colors.js';
import FMOperatorControl from './FMOperatorControl.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import FMGenetix from './FMGenetix.js';
import LFOComponent from 'components/lfo/LFOComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import OscillatorsComponent from './OscillatorsComponent.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'
import EnvelopesComponent from './EnvelopesComponent.js';
import SynthMods from './SynthMods.js';
import {useScroll} from 'components/effects/useScroll.js';
import '../../Instruments.scss';
import '../../Fm.scss';
import {AMP, OP_B1, OP_B2, OP_A, FILTER, PITCH, MODULATION} from 'constants/envelope-types.js';
import {ENVELOPE_OPTIONS} from './constants.js';
import './rack.scss';

const colors = new Colors();

const RackSynthComponent = (props) => { 
    const instrumentRef = useRef(undefined);
    const [showModulators, setShowModulators] = useState(undefined);
    const [formantsExpanded, setFormantsExpanded] = useState(false);
    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref: instrumentRef});
    /*
    const {hideInfo} = useScroll({
        effectRef: instrumentRef,
        scrollContainer: props.scrollContainer[1],
        linkedParameterSelected: props.selectedParameter
    });
    */
    const hideInfo = false;

    const [showWaveform, setShowWaveform] = useState(undefined);
    const [oscillatorDetails, setOscillatorDetails] = useState(undefined);
    const [selectedOscillator, setSelectedOscillator] = useState(0);
    const [showMods, setShowMods] = useState(false);
    let instrument = props.instrument;
    let color = props.color || colors.getColorForTrack(props.track);
    /*
    if (colors.getBrightness(color) > 180) {
        color = colors.brighten(color, 0.6);
    }
    */

    const createController = useCallback(() => {
        let obj = props.track.subSequence.createZObject(0, 0, "synthcontrol");
        obj.effect.linkSynth(props.instrument);
        
    }, [props.instrument]);

    useEffect(() => {
        if (props.selectedFMOperatorDetails !== undefined) {
            setOscillatorDetails(instrument.oscillatorNodes[props.selectedFMOperatorDetails]);
        } else {
            setOscillatorDetails(undefined);
        }
    }, [props.selectedFMOperatorDetails, setOscillatorDetails, instrument]);
    
    let osc = instrument.oscillatorNodes[selectedOscillator];
    let oscDetails = oscillatorDetails;

    useEffect(() => {
        let index = instrument.oscillatorNodes.indexOf(oscillatorDetails);
        setSelectedOscillator(index === -1 ? 0 : index);
    }, [setSelectedOscillator, oscillatorDetails]);

    useEffect(() => {
        if (!props.selectedParameter) {
            return;
        }
        let context = props.selectedParameter.context;
        if (context.instrument === instrument) {
            // parameter is indeed of this instrument
            let subDevice = context.subDevice;
            if (subDevice) {
                if (subDevice.oscillator) {
                    subDevice = subDevice.oscillator;
                }
                let index = instrument.oscillatorNodes.indexOf(subDevice);
                if (index > -1) {
                    setSelectedOscillator(index);
                    setOscillatorDetails(subDevice);
                }
            } else {
                // no sub-device, so set oscillator details to undefined
                // because its not in there...
                setOscillatorDetails(undefined);
            }
        }
    }, [props.selectedParameter,
        instrument,
        setSelectedOscillator,
        setOscillatorDetails]);

    const onClickMods = useCallback(() => {
        setShowMods(!showMods);
    }, [setShowMods, showMods]);
    
    let className = "instrument multi-synth rack-synth";
    if (props.planeMapping) {
        className += " plane-mapping";
    }

    const onClickInstrument = useCallback((e) => {
        e.stopPropagation();
        if (props.planeMapping) {
            props.planeMapping.randomlyMapParameters(
                props.track);
        }
    }, [props.planeMapping, props.instrument]);

    let mods = '';
    let inner = '';
    if (!hideInfo) {
        if (showModulators) {
            let modInner = '';
            if (showModulators === "LFO") {
                modInner = props.track.lfosTrack.lfos.map(
                    lfo => <SingleLFOComponent
                               key={lfo.number}
                               lfo={lfo}
                                               sequencerEngine={props.sequencerEngine}/>);
            } else if (showModulators === "ENVELOPE") {
                modInner = props.track.envelopesTrack.envelopes.map(
                    env => <SystemEnvelopeComponent
                               scrollContainer={props.scrollContainer}
                               key={env.number}
                               envelopeTrack={env}
                               sequencerEngine={props.sequencerEngine}/>);
            }
            mods = (
                <div className="inner showing-mods">
                    <div className="mods-inner">
                        {modInner}
                    </div>
                </div>
            );
        }
        inner = (
            <div>
                <ConditionedComponent condition={!showMods}>
                    <div className="inner">
                      {(!formantsExpanded || !oscillatorDetails) && 
                        <MainFMParameters
                            color={color}
                            track={props.track}
                            osc={osc}
                            scrollContainer={props.scrollContainer}
                            setSelectedOscillator={setSelectedOscillator}
                            sequencerEngine={props.sequencerEngine}
                          instrument={props.instrument}/>}
                        <div>
                            <div className="sections">
                                <div className="instrument-section">
                                    <OperatorsMixer
                                      formantsExpanded={formantsExpanded && oscillatorDetails}
                                      setFormantsExpanded={setFormantsExpanded}
                                      color={color}
                                      setOscillatorDetails={setOscillatorDetails}
                                      oscillatorDetails={oscillatorDetails}
                                      sequencerEngine={props.sequencerEngine}
                                      instrument={instrument}/>
                                  {!showWaveform && !oscillatorDetails ? 
                                   <FilterSection
                                     automation={props.automation}
                                     sequencerEngine={props.sequencerEngine}
                                     instrument={instrument}
                                   /> : ''}
                                </div>
                              {oscDetails && props.showFormantPresets ?
                               <PresetsExplorer
                                 isPianoRoll={false}
                                 initialSize={10}
                                 oscillator={oscDetails || instrument.oscillators[0]}
                                 track={oscDetails || instrument.oscillators[0]}
                                 content={(oscDetails || instrument.oscillators[0]).preset}
                                 searchText={""}
                                 type={"formants"}>
                                 <SaveFormantsFlow oscillator={oscDetails || instrument.oscillators[0]}/>
                              </PresetsExplorer>
                               :
                                  props.formant ?
                               <FormantEffect
                                 track={props.track}
                                 sequencerEngine={props.sequencerEngine}
                                 formant={props.formant} instrument={instrument}/> : 
                               <div className="instrument-section envelopes">
                                 <div className="instrument-subsection envelopes">
                                   <EnvelopesComponent
                                     color={color}
                                             automation={props.automation}
                                             envelopeOptions={ENVELOPE_OPTIONS}
                                             sequencerEngine={props.sequencerEngine}
                                             instrument={instrument}/>
                                     </div>
                                     <div className="aux-parameters">
                                         <OscillatorsContinuedComponent
                                             instrument={instrument}
                                             selectedOscillator={selectedOscillator}
                                             sequencerEngine={props.sequencerEngine}
                                         />
                                         <div className="mods-container">
                                             <div onClick={() => setShowModulators(
                                                      showModulators === "LFO" ?
                                                          undefined : "LFO")}
                                                  className={showModulators === "LFO" ?
                                                             "mod-type-btn selected pushable " : "mod-type-btn pushable"}>
                                                 LFOs
                                             </div>
                                             <div
                                                 onClick={() => setShowModulators(
                                                     showModulators === "ENVELOPE" ?
                                                         undefined :
                                                         "ENVELOPE")}
                                                 className={showModulators === "ENVELOPE" ?
                                                            "mod-type-btn selected pushable" : "mod-type-btn pushable"}>
                                                 ENVs
                                             </div>
                                             <div onClick={onClickMods} className="mod-type-btn pushable">
                                                 MODS
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                                }
                            </div>
                        </div>
                    </div>
                </ConditionedComponent>
                <ConditionedComponent condition={showMods}>
                    <div className="clear-fix"/>
                    <SynthMods instrument={instrument}/>
                    <div
                        onClick={onClickMods}
                        className="mods-button common-button small-button">
                        {showMods ? 'BACK' : 'MODS'}
                    </div>
                </ConditionedComponent>
            </div>
        );
    }

    return (
        <div
          //onContextMenu={onContextMenu}
          ref={instrumentRef}
          onClick={onClickInstrument}
          className={className}>
          <ContextMenu dropdownPos={dropdownPos} setDropdownPos={setDropdownPos}>
            <MenuItem onMouseDown={createController}>
              Create Controller Object
            </MenuItem>
          </ContextMenu>
          {hideInfo ? <div style={hideInfo}/> : inner}
          {mods}
        </div>);
}

const mapStateToProps = (state, props) => {
    let {instrument} = props;
    let oscillators = instrument.oscillatorNodes;
    if (!oscillators) {
        return {};
    }
    return {
        preset1: oscillators[0].preset,
        preset2: oscillators[1].preset,
        preset3: oscillators[2].preset,
        preset4: oscillators[3].preset,
        selectedParameter: state.effects.accumulatorParameterSelected,
        planeMapping: state.effects.planeMapping,
        presetName: props.track.presetName,
        formant: state.instruments.showFormantEffect,
        selectedFMOperatorDetails: state.instruments.selectedFMOperatorDetails,
        showFormantPresets: state.instruments.showFormantPresets
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RackSynthComponent);
